import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderViewComponent } from './components/loader-view/loader-view.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';



@NgModule({
  declarations: [LoaderViewComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  exports: [
    LoaderViewComponent
  ]
})
export class LoaderModule { }
